import { sendGet } from "api/restUtil";
import {useEffect, useMemo, useState} from 'react';
import SearchList from 'components/SearchList';
import ReactDataTableDisplay from 'components/DataTable/ReactDataTableDisplay';

import { getUserInfo, hasAdminAuth } from "api/commonUtil";
import BranchOptionModModal from "./BranchOptionModModal";
import BranchOptionStockCntModModal from "./BranchOptionStockCntModModal";

// 지점 상품 목록
function BranchProductList() {

	//데이터 목록
	const [ dataList, setDataList ] = useState([]);
	//초기 검색 조건 데이터
	const [ initialCondition, setInitialCondition] = useState({});
	//검색 데이터
	const [ condition, setCondition] = useState({});
	// 페이징 정보
	const [ pagingInfo, setPagingInfo ] = useState({});
	// 재고 수정할 데이터
	const [ modStockCntInitData, setModStockCntInitData ] = useState({});
	// 지점 수정 팝업
	const [ isOpenStockCntModal, setIsOpenStockCntModal] = useState(false);

	//검색 조건
	const conditionList = [
		{
			title : "상품 명",
			col : "productName",
			type : "input",
		},
		{
			title : "채널 상품 번호",
			col : "channelProductNo",
			type : "input",
		},
		{
			title: "카테고리",
			col: "leafCategoryIdSff",
			type: "commonCodeSelect",
			grpCd: "LEAF_CATEGORY_SFF",
		},
		{
			title : "표시건수",
			col : "cntPerPage",
			type : "select",
			option: [
				{label: "10개씩보기", value: 10},
				{label: "20개씩보기", value: 20},
				{label: "50개씩보기", value: 50},
				{label: "100개씩보기", value: 100},
			],
		},
	];

	// 재고 수정 팝업
	const modStockCnt = async (data) => {
		setModStockCntInitData({channelProductNo : data.channelProductNo});
		setIsOpenStockCntModal(true);
	}
	
	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		{ header : "채널 상품 번호", col : "channelProductNo", cellWidth: "100"},
		{ header : "상품명", col : "productName", cellWidth : "100" },
		{ header : "이미지", col : "imageUrl", type: "image", cellWidth : "100" },
		{ header : "재고관리", col : "channelProductNo",cellWidth : "30", type : "modButton", onClick: modStockCnt, label: "관리"},
	], []);

	useEffect(() =>{
		const initData = async () => {
			
			//초기 검색 조건
			setInitialCondition({});
			searchList({});
		};

		initData();

	}, []);

	//목록 조회
	const searchList = async (cond = {}) => {

		let result = await sendGet("/api/mgmt/product", cond);
		if(result.respCode === "SUCCESS"){

			setCondition(cond);

			const dataList = result.data.list;
			dataList.forEach(data => {
				if(data.activationYn) {
					data.activationYnStr = "Y";
				} else {
					data.activationYnStr = "N";
				}
			});
			setDataList(result.data.list);
			setPagingInfo({...result.data, searchFnc : searchList, searchCond : cond});
		}
	}

	// 재고 수정
	const modBranchOptionStockCnt = async (data) => {

	}


	return (
		<div className="ant-tabs-tabpane">
			<SearchList conditionList={conditionList} onSearch={searchList} initialData={initialCondition} />

			<ReactDataTableDisplay
				columns={columns}
				customDatas={dataList}
				hideCheckBox={true}
				percentageWidth={true}
				isPageNation={false}
				rowClick={"checkbox"}
				pagingInfo={pagingInfo}
			/>
			{/* 지점 옵션 재고 수정 팝업 */}
			<BranchOptionStockCntModModal
				isOpen={isOpenStockCntModal}
				initData={modStockCntInitData}
				returnData={modBranchOptionStockCnt}
				onClose={()=> {setIsOpenStockCntModal(false); setModStockCntInitData({});}}
				title="재고 수정"
			/>

		</div>
	);
}

export default BranchProductList;